import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/RegionsTable.vue"),
          meta: { title: "Список регионов", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/RegionsForm.vue"),
          meta: { title: "Создать регион", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/RegionsForm.vue"),
          meta: { title: "Редактировать регион", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
